import classnames from "classnames";
import React, { ReactNode } from "react";
import styles from "./Wrapper.module.scss";
import { findDataAttrProps } from "../../../utils/props";

type Props = {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const Wrapper = (props: Props) => {
  const { children, className, style } = props;
  const cssStyles = classnames(
    "wrapper",
    "container-fluid",
    styles.wrapper,
    className
  );

  return (
    <div {...findDataAttrProps(props)} style={style} className={cssStyles}>
      {children}
    </div>
  );
};

export default Wrapper;
